import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import scrollToComponent from 'react-scroll-to-component';
import { FormattedMessageWrappedInSpan } from '../components/misc';
import { Redirect } from 'react-router-dom';

import EventOnlineView from '../components/content/event/EventOnlineView';
import Faq from '../components/content/Faq';
import InsufficientResultsInformation from '../components/content/informations/InsufficientResultsInformation';
import SecondFactorErrorMsg from '../components/messages/SecondFactorErrorMsg';
import LoadingView from '../components/content/LoadingView';
import MediaList from '../components/content/lists/MediaList';
import ParticipantMediaList from '../components/content/lists/ParticipantMediaList';
import SearchInstructionsDialog from '../components/content/dialogs/SearchInstructionsDialog';
import CustomDialog from '../components/content/dialogs/CustomDialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Pricelist from '../components/content/event/Pricelist';
import PaymentMethodView from '../components/content/PaymentMethodView';

import {
  hasMedia,
  hasEnoughMedia,
  getFotoFlat,
  getSinglePhoto,
  getVideo,
  getCertificate,
  includesVideo,
  includesCertificate,
} from '../utils/common';
import { FACTOR_EMAIL, FACTOR_CODE } from '../utils/variables';
import EmbeddedVideo from '../components/misc/EmbeddedVideo';
import { setCustomerKey, setToLocalStorage } from '../utils/browser-storage';
import { trackEvent } from '../utils/ga-tracking';
import { UserConsumer } from '../components/context/UserContext';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

class EventSnSearchPage extends Component {
  constructor(props) {
    super(props);

    const { event } = props.viewer;
    var initialSelectedTab;
    switch (true) {
      case event.searchDual:
        initialSelectedTab = 3;
        break;
      case event.smartSearch && hasMedia(event.participant):
        initialSelectedTab = 0;
        break;
      case event.searchCollections:
        initialSelectedTab = 1;
        break;
      case event.gps:
        initialSelectedTab = 2;
        break;
      default:
        initialSelectedTab = 1;
    }

    this.state = {
      isLoading: false,
      extendedSearchSelectedTab: initialSelectedTab,
      extendedSearchExpand: false,
      showSearchInstructionsDialog: this._shouldShowSearchInstructionsDialog(),
      shouldLoadImpressions: false,
      formPositionRef: null,
      showCertificateInformation: false,
      // attemptsCount: 0,
    };

    this._refetchMediaForNewStartnumber = this._refetchMediaForNewStartnumber.bind(this);
    this.handleScrollToImpressions = this.handleScrollToImpressions.bind(this);
    this.handleScrollToVoucher = this.handleScrollToVoucher.bind(this);
    this.handleScrollToVideo = this.handleScrollToVideo.bind(this);
    this.handleScrollToCertificate = this.handleScrollToCertificate.bind(this);
    this.scrollingToFotoFlatInMediaMasonry =
      this.scrollingToFotoFlatInMediaMasonry.bind(this);
    this.liftingUpFotoFlatPositionData = this.liftingUpFotoFlatPositionData.bind(this);
    this.getVideoUrl = this.getVideoUrl.bind(this);
    this.liftingUpFormPositionData = this.liftingUpFormPositionData.bind(this);
    this.scrollToForm = this.scrollToForm.bind(this);
    this.getCertificatePreview = this.getCertificatePreview.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.isLoading) {
      return {
        extendedSearchSelectedTab: hasMedia(nextProps.viewer.event.participant) ? 0 : 1,
      };
    }
    return null;
    // if (!prevState.isLoading) {
    //   if (nextProps.viewer.event.participant.media.mediaInfo.count === 0) {
    //     return { attemptsCount: prevState.attemptsCount + 1 };
    //   }
    // }
    // return null;
  }

  componentDidMount() {
    const { viewer, snFromUrl, customerKey, codeSecondFactorForFaceEvent } = this.props;

    if (Boolean(this.props.viewer.event.participant) && snFromUrl) {
      this._scrollToMediaSection();
    }

    if (customerKey && viewer.event.participant) {
      setCustomerKey(viewer.event.sgId, snFromUrl, customerKey);
    }

    if (codeSecondFactorForFaceEvent && viewer.event.participant) {
      setToLocalStorage(`${viewer.event.sgId}-code`, codeSecondFactorForFaceEvent);
    }

    //in case we don't get the callback from MediaListMasonry
    this.imagesLoadedFallback = setTimeout(this.handleImagesLoaded, 5000);

    // track if no media where found
    if (!hasMedia(viewer.event.participant)) {
      this._trackNoMediaFound(snFromUrl);
    }
  }

  componentDidUpdate(prevProps) {
    const { snFromUrl, customerKey } = this.props;
    if (snFromUrl !== prevProps.snFromUrl || customerKey !== prevProps.customerKey) {
      this._refetchMediaForNewStartnumber(snFromUrl, customerKey);
    }
  }

  componentWillUnmount() {
    this.clearImagesLoadedFallback();
  }

  getVideoUrl = (event) => {
    const videoUrl = getVideo(event.products).configuration.previewVideoUrl;
    return videoUrl;
  };

  getCertificatePreview = (eventProducts) => {
    return getCertificate(eventProducts).configuration.previewImageUrl;
  };

  handleExtendedSearchTabChanged = (event, value) => {
    this.setState({
      extendedSearchSelectedTab: value,
      extendedSearchExpand: true,
    });
  };

  handleExtendedSearchExpand = () => {
    this.setState((prevState) => ({
      extendedSearchExpand: !prevState.extendedSearchExpand,
    }));
  };

  handleSearchTriggered = () => {
    this.setState({ extendedSearchExpand: false });
  };

  handleDeepSearchBtnClicked = () => {
    this.scrollToExtendedSearch(0);
  };

  handleCategorySearchBtnClicked = () => {
    this.scrollToExtendedSearch(1);
  };

  handleGpsSearchBtnClicked = () => {
    this.scrollToExtendedSearch(2);
  };

  handleScrollToImpressions() {
    scrollToComponent(this.impressions, { align: 'top' });
  }

  handleScrollToEvent() {
    scrollToComponent(this.impressions, { align: 'top' });
  }

  handleScrollToVoucher() {
    scrollToComponent(this.voucher, { align: 'middle' });
    trackEvent('Event', 'Voucher', 'Offer Foto-Flat');
  }

  handleScrollToVideo() {
    scrollToComponent(this.video, { align: 'center' });
  }

  handleScrollToCertificate() {
    if (this.certificate != null) {
      scrollToComponent(this.certificate, { align: 'top' });
    } else {
      this.setState({ showCertificateInformation: true });
    }
  }

  clearImagesLoadedFallback = () => {
    if (this.imagesLoadedFallback) {
      clearTimeout(this.imagesLoadedFallback);
      this.imagesLoadedFallback = null;
    }
  };

  handleImagesLoaded = () => {
    if (!this.state.shouldLoadImpressions) {
      this.clearImagesLoadedFallback();
      this.setState({
        shouldLoadImpressions: true,
      });
    }
  };

  scrollToExtendedSearch(selectedTabIndex) {
    scrollToComponent(this.eventOnlineView);
    this.setState({
      extendedSearchExpand: true,
      extendedSearchSelectedTab: selectedTabIndex,
    });
  }

  scrollingToFotoFlatInMediaMasonry() {
    if (getFotoFlat(this.props.viewer.event.products)) {
      scrollToComponent(this.fotoFlatPosition.current, { align: 'top' });
    }
  }

  liftingUpFotoFlatPositionData(fotoFlatPositionRef) {
    this.fotoFlatPosition = fotoFlatPositionRef;
  }

  liftingUpFormPositionData(formPositionRef) {
    this.setState({
      formPositionRef: formPositionRef,
    });
  }

  scrollToForm() {
    scrollToComponent(this.state.formPositionRef, { align: 'top' });
  }

  _refetchMediaForNewStartnumber(newStartnumber, customerKey) {
    this.setState({ isLoading: true });
    this.props.relay.refetch(
      { startnumber: newStartnumber, secondFactor: customerKey },
      null,
      () => {
        this.setState({
          isLoading: false,
          showSearchInstructionsDialog: this._shouldShowSearchInstructionsDialog(),
        });
        const { viewer, snFromUrl, customerKey } = this.props;
        if (customerKey && viewer.event.participant && !viewer.event.searchByFace) {
          setCustomerKey(viewer.event.sgId, snFromUrl, customerKey);
        }

        // track if no media were found
        if (!hasMedia(viewer.event.participant)) {
          this._trackNoMediaFound(snFromUrl);
        }
      }
    );
  }

  _shouldShowSearchInstructionsDialog() {
    const { participant, products, warnText } = this.props.viewer.event;
    return (
      !hasEnoughMedia(
        participant && participant.media.mediaInfo.count,
        getFotoFlat(products),
        getSinglePhoto(products)
      ) && Boolean(warnText)
    );
  }

  _scrollToMediaSection() {
    if (this.mediaSection) {
      scrollToComponent(this.mediaSection, { align: 'top' });
    }
  }

  _trackNoMediaFound(startNumber) {
    trackEvent('Event', 'Search', 'No photos found for start number', {
      nonInteraction: true,
    });
  }

  render() {
    const { viewer, snFromUrl, customerKey, codeSecondFactorForFaceEvent } = this.props;
    const { event } = viewer;
    let videoUrl = null;
    let certificateImgPreview = null;
    const userLoginEmail = viewer.account && String(viewer.account.profile.email).trim();

    if (includesVideo(event.products)) {
      videoUrl = this.getVideoUrl(event);
    }

    if (includesCertificate(event.products)) {
      certificateImgPreview = this.getCertificatePreview(event.products);
    }

    if (event.legacy) {
      window.location.href = `https://archive.sportograf.com/shop/search/${event.sgId}/${event.participant.startnumber}`;
      return null;
    }

    if (
      !viewer.account &&
      !event.participant &&
      event.secondFactorType.type === 'Email'
    ) {
      return (
        <Redirect to={`/event/${event.sgId}/secondFactorRedirection/${snFromUrl}`} />
      );
    }

    if (event.state === 'reminder') {
      return <Redirect to={`/event/${event.sgId}`} />;
    }

    const {
      extendedSearchSelectedTab,
      extendedSearchExpand,
      isLoading,
      showSearchInstructionsDialog,
      shouldLoadImpressions,
      userWantToCorrectStartnumber,
      formPositionRef,
      // attemptsCount,
    } = this.state;

    const participantMediaCount = event.participant
      ? event.participant.media.mediaInfo.count
      : 0;
    const { count: impressionMediaCount } = event.impressionMedia.mediaInfo;
    const hasExtendedOptions =
      event.gps ||
      event.searchDual ||
      (event.smartSearch && participantMediaCount !== 0) ||
      event.searchCollections;

    return (
      <UserConsumer>
        {({ onLoginChange, isLoggedIn }) => (
          <div
            className="container-960 container-page"
            ref={(div) => (this.eventCard = div)}
          >
            <EventOnlineView
              ref={(view) => (this.eventOnlineView = view)}
              onlineEvent={event}
              urlSn={snFromUrl}
              customerKey={customerKey}
              extendedSearchSelectedTab={extendedSearchSelectedTab}
              extendedSearchExpand={extendedSearchExpand}
              hasSmartSearchTab={event.smartSearch && participantMediaCount !== 0}
              hasGpsSearchTab={event.gps}
              hasExtendedSearch={event.participant !== null && hasExtendedOptions}
              hasDualSearchTab={event.searchDual}
              showSearchInstructionsDialog={showSearchInstructionsDialog}
              onExtendedSearchTabChange={this.handleExtendedSearchTabChanged}
              onExtendedSearchExpand={this.handleExtendedSearchExpand}
              onSearchTrigger={this.handleSearchTriggered}
              handleScrollToOffer={this.scrollingToFotoFlatInMediaMasonry}
              setFotoFlatRef={this.liftingUpFotoFlatPositionData}
              setFormRef={this.liftingUpFormPositionData}
              shouldShowAdditionalInstruction={
                !event.participant && event.secondFactorType.type === FACTOR_EMAIL
              }
              userLoginEmail={userLoginEmail}
              isAccessGrantedByValidCodeFaceEvent={
                Boolean(event.participant) &&
                event.searchByFace &&
                event.secondFactorType?.type === FACTOR_CODE
              }
              isParticipant={event.participant && event.participant != null}
              codeSecondFactorForFaceEvent={codeSecondFactorForFaceEvent}
              userWantToCorrectStartnumber={userWantToCorrectStartnumber}
              shouldShowAdditionalOffer={
                participantMediaCount !== 0 &&
                getFotoFlat(event.products) &&
                (includesVideo(event.products) ||
                  includesCertificate(event.products) ||
                  event.voucherCampaign != null)
              }
            />
            <div
              ref={(div) => {
                this.mediaSection = div;
              }}
            >
              {isLoading && <LoadingView />}
              {!isLoading && (
                <>
                  {!event.participant && (
                    <SecondFactorErrorMsg
                      event={event}
                      onScrollToForm={this.scrollToForm}
                      userLoginEmail={userLoginEmail}
                      isLoggedIn={isLoggedIn}
                      onLoginChange={onLoginChange}
                      userIsOnTheNumberSearch={Boolean(formPositionRef)}
                    />
                  )}
                  {event.participant && participantMediaCount !== 0 && (
                    <Fragment>
                      <div className="row">
                        <div className="col-xs-16 col-sm-12 col-sm-offset-2 search-page-header-with-hint ">
                          <h1 className="separator">
                            {event.searchByFace && (
                              <FormattedMessageWrappedInSpan
                                id="eventSnSearchPage.searchByFace.participantSubtitle"
                                defaultMessage="We found {count, plural, one {# photo} other {# photos}} related to your photo"
                                values={{ count: participantMediaCount }}
                              />
                            )}
                            {!event.searchByFace && (
                              <FormattedMessageWrappedInSpan
                                id="eventSnSearchPage.participantSubtitle"
                                defaultMessage="We found {count, plural, one {# photo} other {# photos}} related to your bib number"
                                values={{ count: participantMediaCount }}
                              />
                            )}
                            {hasExtendedOptions && (
                              <div
                                className="extended-search-expand"
                                onClick={this.handleExtendedSearchExpand}
                              >
                                {!extendedSearchExpand && (
                                  <>
                                    <div className="extended-search-expand-desktop">
                                      <FormattedMessageWrappedInSpan
                                        id="extendedSearch.morePhotosDesktop"
                                        defaultMessage="+ Are there more photos of me?"
                                      />
                                    </div>
                                    <div className="extended-search-expand-mobile">
                                      <FormattedMessageWrappedInSpan
                                        id="extendedSearch.morePhotosMobile"
                                        defaultMessage="More?"
                                      />
                                    </div>
                                  </>
                                )}
                                {extendedSearchExpand && (
                                  <>
                                    <div className="extended-search-expand-desktop">
                                      <FormattedMessageWrappedInSpan
                                        id="extendedSearch.hideMorePhotosDesktop"
                                        defaultMessage="- Hide extended search options"
                                      />
                                    </div>
                                    <div className="extended-search-expand-mobile">
                                      <FormattedMessageWrappedInSpan
                                        id="extendedSearch.hideMorePhotosMobile"
                                        defaultMessage="Hide"
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </h1>
                        </div>
                      </div>
                      <ParticipantMediaList
                        eventHasSearchByFace={event.searchByFace ? true : false}
                        eventHasSecondFactor={event.secondFactorType ? true : false}
                        eventId={event.sgId}
                        startnumber={event.participant.startnumber}
                        customerKey={customerKey}
                        hasMorePhotosButton={
                          participantMediaCount <= event.morePhotosButtonCount &&
                          hasExtendedOptions
                        }
                        participantMedia={event.participant.media}
                        offer={event}
                        participantMediaCount={participantMediaCount}
                        impressionMediaCount={impressionMediaCount}
                        hasVideoUrl={Boolean(videoUrl)}
                        onScrollToImpressions={this.handleScrollToImpressions}
                        onScrollToVoucher={this.handleScrollToVoucher}
                        onScrollToVideo={this.handleScrollToVideo}
                        onScrollToCertificate={this.handleScrollToCertificate}
                        onScrollToExtendedSearch={() =>
                          this.scrollToExtendedSearch(extendedSearchSelectedTab)
                        }
                        onImagesLoaded={this.handleImagesLoaded}
                        setFotoFlatRef={this.liftingUpFotoFlatPositionData}
                        hasCertificates={includesCertificate(event.products)}
                      />
                    </Fragment>
                  )}
                  {event.participant && participantMediaCount < 6 && snFromUrl && (
                    <InsufficientResultsInformation
                      count={participantMediaCount}
                      raceResultsUrl={event.hostResultUrl}
                      showExtendedSearchAsAvailable={hasExtendedOptions}
                      showGpsSearchLink={event.gps}
                      showCollectionsLink={event.searchCollections}
                      showSmartSearchLink={event.smartSearch}
                      tagWithStartNumber={!event.searchByFace}
                      onDeepSearchClick={this.handleDeepSearchBtnClicked}
                      onCategorySearchClick={this.handleCategorySearchBtnClicked}
                      onGpsSearchClick={this.handleGpsSearchBtnClicked}
                      isFaceSearchEvent={event.searchByFace}
                      scrollToEvent={this.scrollToForm}
                      onScrollToExtendedSearch={() =>
                        this.scrollToExtendedSearch(extendedSearchSelectedTab)
                      }
                    />
                  )}
                  {snFromUrl &&
                    event.participant &&
                    event.voucherCampaign &&
                    event.voucherCampaign.longText && (
                      <React.Fragment>
                        <div className="row">
                          <h1 className="separator col-xs-16 col-sm-12 col-sm-offset-2" />
                        </div>
                        <div className="row mb-30" ref={(div) => (this.voucher = div)}>
                          <div className="voucher-container col-xs-16 col-sm-8 col-sm-offset-4">
                            <div
                              className="voucher-text"
                              dangerouslySetInnerHTML={{
                                __html: event.voucherCampaign.longText,
                              }}
                            />
                            <div className="voucher-banner">
                              <a
                                href={event.voucherCampaign.url}
                                onClick={() =>
                                  trackEvent('Event', 'Voucher', 'Banner Foto-Flat')
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img src={event.voucherCampaign.banner} />
                              </a>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  {event.participant &&
                    includesVideo(event.products) &&
                    videoUrl &&
                    snFromUrl && (
                      <div
                        ref={(div) => (this.video = div)}
                        className="event-search-video"
                      >
                        <div className="row">
                          <div className="col-xs-16 col-sm-12 col-sm-offset-2">
                            <h1 className="separator">
                              <FormattedMessageWrappedInSpan
                                id="eventSnSearchPage.videoSubtitle"
                                defaultMessage="This event has a personalized video"
                              />
                              <EmbeddedVideo videoUrl={videoUrl} />
                            </h1>
                          </div>
                        </div>
                      </div>
                    )}
                  {snFromUrl &&
                    event.participant &&
                    includesCertificate(event.products) &&
                    certificateImgPreview && (
                      <div
                        ref={(div) => (this.certificate = div)}
                        className="event-search-certificate"
                      >
                        <div className="row">
                          <div className="col-xs-16 col-sm-12 col-sm-offset-2">
                            <h1 className="separator">
                              <FormattedMessageWrappedInSpan
                                id="eventSnSearchPage.certificateSubtitle"
                                defaultMessage="This event has a printable participant certificate"
                              />
                              <div className="certificate-dialog-image ">
                                <img
                                  src={certificateImgPreview}
                                  alt="certificate preview"
                                />
                              </div>
                            </h1>
                          </div>
                        </div>
                      </div>
                    )}
                  {snFromUrl &&
                    event.participant &&
                    impressionMediaCount > 0 &&
                    shouldLoadImpressions && (
                      <div ref={(div) => (this.impressions = div)}>
                        <div className="row">
                          <div className="col-xs-16 col-sm-12 col-sm-offset-2">
                            <h1 className="separator">
                              <FormattedMessageWrappedInSpan
                                id="eventSnSearchPage.impressionSubtitle"
                                defaultMessage="This event has {count, plural, one {# impression} other {# impressions}}"
                                values={{ count: impressionMediaCount }}
                              />
                            </h1>
                          </div>
                        </div>
                        <MediaList
                          eventHasSearchByFace={event.searchByFace ? true : false}
                          eventHasSecondFactor={event.secondFactorType ? true : false}
                          media={event.impressionMedia.mediaList}
                          offer={event}
                          impressionMediaCount={impressionMediaCount}
                          participantMediaCount={participantMediaCount}
                          listType="impressions"
                          startnumber={event.participant.startnumber}
                          onScrollToImpressions={this.handleScrollToImpressions}
                          onScrollToVoucher={this.handleScrollToVoucher}
                          onScrollToVideo={this.handleScrollToVideo}
                          onScrollToCertificate={this.handleScrollToCertificate}
                          hasVideoUrl={Boolean(videoUrl)}
                          onScrollToExtendedSearch={() => this.scrollToExtendedSearch()}
                          hasCertificates={includesCertificate(event.products)}
                          hasCertificateUrl={Boolean(certificateImgPreview)}
                        />
                      </div>
                    )}
                </>
              )}
            </div>
            {codeSecondFactorForFaceEvent && event.participant && !snFromUrl && (
              <>
                <Pricelist
                  offer={event}
                  hasCertificates={includesCertificate(event.products)}
                />
                <PaymentMethodView />
              </>
            )}
            {snFromUrl && (
              <Faq
                eventHasSearchByFace={event.searchByFace ? true : false}
                onFindMore={() => this.scrollToExtendedSearch()}
              />
            )}
            <SearchInstructionsDialog
              open={showSearchInstructionsDialog}
              message={event.warnText}
              onAccept={() => this.setState({ showSearchInstructionsDialog: false })}
            />
            <CustomDialog open={this.state.showCertificateInformation}>
              <div className="notification-container">
                <DialogContent>
                  <div className="notification-body">
                    <h1>
                      <FormattedMessageWrappedInSpan
                        id="pricelist.dialog.certificate.title"
                        defaultMessage="What is certificate?"
                        className="mb-15"
                      />
                    </h1>
                    <FormattedMessageWrappedInSpan
                      id="pricelist.dialog.certificate"
                      defaultMessage="You can create a certificate with a photo of your choice from the pictures of your Foto-Flat and with your personal data. You can download and print it."
                    />
                  </div>
                </DialogContent>
                <DialogActions>
                  <div className="notification-action">
                    <button
                      className="accept"
                      onClick={() => this.setState({ showCertificateInformation: false })}
                    >
                      <FormattedMessageWrappedInSpan
                        id="searchInstructionsDialog.acceptButton"
                        defaultMessage="OK"
                      />
                    </button>
                  </div>
                </DialogActions>
              </div>
            </CustomDialog>
          </div>
        )}
      </UserConsumer>
    );
  }
}

EventSnSearchPage.propTypes = {
  snFromUrl: PropTypes.string,
  customerKey: PropTypes.string,
  viewer: PropTypes.object,
  relay: PropTypes.object,
  codeSecondFactorForFaceEvent: PropTypes.string,
};

export { EventSnSearchPage };

export default createRefetchContainer(
  EventSnSearchPage,
  {
    viewer: graphql`
      fragment EventSnSearchPage_viewer on Viewer {
        account {
          profile {
            email
          }
        }
        event(id: $eventId, language: $language) {
          id
          sgId
          gps
          legacy
          hostResultUrl
          impressionMedia {
            mediaInfo {
              count
            }
            mediaList(first: 100) {
              ...MediaList_media
            }
          }
          morePhotosButtonCount
          participant(startnumber: $startnumber, secondFactor: $secondFactor) {
            media {
              mediaInfo {
                count
              }
              ...ParticipantMediaList_participantMedia
            }
            startnumber
          }
          products {
            id
            mediaCollection {
              name
            }
            price
            type
            configuration {
              ... on SingleVideoConfiguration {
                previewVideoUrl
              }
              ... on EventCertificateConfiguration {
                previewImageUrl
              }
            }
          }
          secondFactorType {
            type
          }
          searchByFace
          searchDual
          smartSearch
          searchCollections
          state
          voucherCampaign {
            banner
            longText
            url
          }
          warnText
          ...EventOnlineView_onlineEvent
          ...ParticipantMediaList_offer
          ...MediaList_offer
          ...Pricelist_offer
        }
      }
    `,
  },
  graphql`
    query EventSnSearchPageRefetchQuery(
      $eventId: ID!
      $startnumber: ID!
      $count: Int!
      $cursor: String
      $language: String
      $secondFactor: String
      $individualPart: String
    ) {
      viewer {
        ...EventSnSearchPage_viewer
      }
    }
  `
);
